
import { AdminConfigLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AdminConfigLogEntryContent extends Vue {
  @Prop()
  logEntry!: AdminConfigLogEntry
}
